import { createEffect, ParentProps } from 'solid-js'
import styles from './st-markdown.module.css'
import { marked } from 'marked'
import DOMPurify from 'dompurify'
const { sanitize } = DOMPurify;

export class MarkdownProps {
    content?: string = '';
}

export default function Markdown(props: ParentProps<MarkdownProps>) {
    let div: HTMLDivElement | undefined;

    const render = async (el: HTMLDivElement) => {
        el.innerHTML = ''; // Clear previous content
        if (props.content) {
            const rendered = await marked.parse(props.content)
            const sanitized = sanitize(rendered)
            el.innerHTML = sanitized;
        }
    }

    createEffect(() => {
        const _ = props.content;
        if (div) {
            render(div);
        }
    })

    return (
        <div class={styles['st-markdown']} ref={(el) => { div = el; render(el); }}>
            {props.children}
        </div>
    );
}

Markdown.defaultProps = new MarkdownProps();